import script from "./bannerHero.vue?vue&type=script&setup=true&lang=js"
export * from "./bannerHero.vue?vue&type=script&setup=true&lang=js"

import "./bannerHero.vue?vue&type=style&index=0&id=0e91cbbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e91cbbf"]])

export default __exports__